export const REPORT_TYPES = [
  "Adls",
  "Mars",
  "Behaviors",
  "UT Incidents",
  "NV Incidents"
]